import shortid from 'shortid'
import { compose, match, last, always, curry } from 'ramda'

// by default, shortid includes '_' chars
// we don't want to include them so we can parse the entity from the tempid
shortid.characters(
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@'
)

const safeMatch = curry((regex, string) =>
  string ? match(regex, string) : always([])
)

const makeTempId = (entity, entityId) =>
  `tmp_${entity}_${entityId || shortid.generate()}`
const makeRandId = (whatItIs) => `${whatItIs}_${shortid.generate()}`
const tempIdEntity = (item) => item || compose(last, safeMatch(/_(.*)_/))(item)

export { makeTempId, makeRandId, tempIdEntity }
